/**
 * Recently Viewed Products - fetches product cards via Section Rendering API
 */
(function() {
  function localeRoot(fromEl) {
    var root = (fromEl && fromEl.dataset && fromEl.dataset.localeRoot) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function getSectionHtml(data, sectionId) {
    if (!data) return null;
    if (data[sectionId] && typeof data[sectionId] === 'string') return data[sectionId];
    var values = Object.values(data);
    for (var i = 0; i < values.length; i++) {
      if (typeof values[i] === 'string' && values[i].trim()) return values[i];
    }
    return null;
  }

  function forgetRecentlyViewedHandles(handles) {
    if (!handles || !handles.length || !window.localStorage) return;
    try {
      var key = 'recently-viewed';
      var stored = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(stored)) return;
      var drop = {};
      handles.forEach(function(handle) {
        if (handle) drop[handle] = true;
      });
      var next = stored.filter(function(handle) { return !drop[handle]; });
      if (next.length !== stored.length) localStorage.setItem(key, JSON.stringify(next));
    } catch (e) {}
  }

  function storefrontProductBlock(wrap) {
    if (!wrap) return null;
    var skip = wrap.querySelector('[data-rv-skip]');
    if (skip) return { skip: skip.getAttribute('data-rv-skip') || 'missing' };
    var block = wrap.querySelector('.product-block, product-block');
    if (!block) return { skip: 'empty' };
    var id = (block.getAttribute('data-product-id') || '').trim();
    var handle = (block.getAttribute('data-product-handle') || '').trim();
    if (!id || !handle) return { skip: 'missing' };
    return { block: block };
  }

  function initRecentlyViewedProducts() {
    const section = document.querySelector('.recently-viewed-products');
    if (!section) return;

    const container = section.querySelector('.recently-viewed-products__grid');
    const currentHandle = section.dataset.productHandle || '';
    const sectionId = section.dataset.sectionRenderId || 'recently-viewed-card';
    const max = parseInt(section.dataset.grid, 10) || 4;
    const designMode = section.dataset.designMode === 'true';
    const emptyMessage = section.dataset.emptyMessage || 'Recently viewed products will appear here.';

    let recentHandles = [];
    try {
      const stored = localStorage.getItem('recently-viewed');
      if (stored) recentHandles = JSON.parse(stored);
    } catch (e) {}

    recentHandles = recentHandles.filter(function(h) { return h && h !== currentHandle; });
    if (window.theme && typeof theme.filterProductListingHandles === 'function') {
      recentHandles = theme.filterProductListingHandles(recentHandles);
    }

    if (recentHandles.length === 0) {
      if (designMode) {
        section.classList.remove('recently-viewed-products--hidden');
        container.querySelector('noscript')?.remove();
        var placeholder = document.createElement('p');
        placeholder.className = 'align-center recently-viewed-products__placeholder';
        placeholder.textContent = emptyMessage;
        container.innerHTML = '';
        container.appendChild(placeholder);
        return;
      }
      section.classList.add('recently-viewed-products--hidden');
      return;
    }

    const requests = recentHandles.map(function(handle) {
      var url = localeRoot(section) + 'products/' + encodeURIComponent(handle) + '?sections=' + encodeURIComponent(sectionId);
      return fetch(url).then(function(r) {
        if (r.status === 404) return { handle: handle, missing: true };
        if (!r.ok) return { handle: handle, failed: true };
        return r.json().then(function(data) {
          return { handle: handle, data: data };
        }).catch(function() {
          return { handle: handle, failed: true };
        });
      }).catch(function() {
        return { handle: handle, failed: true };
      });
    });

    Promise.all(requests).then(function(responses) {
      const productBlocks = [];
      const forgetHandles = [];
      responses.forEach(function(result) {
        if (!result || result.failed || result.missing) return;
        const html = getSectionHtml(result.data, sectionId);
        if (!html) return;
        const wrap = document.createElement('div');
        wrap.innerHTML = html;
        const parsed = storefrontProductBlock(wrap);
        if (parsed && parsed.block) {
          productBlocks.push(parsed.block.outerHTML);
          return;
        }
        if (parsed && (parsed.skip === 'missing' || parsed.skip === 'excluded')) {
          forgetHandles.push(result.handle);
        }
      });
      forgetRecentlyViewedHandles(forgetHandles);
      if (productBlocks.length > max) productBlocks.length = max;

      if (productBlocks.length > 0) {
        container.innerHTML = '';
        const sectionEl = container.closest('.recently-viewed-products');
        const wrapEach = sectionEl && sectionEl.dataset.enableCarousel === 'true';
        const html = wrapEach
          ? productBlocks.map(function(b) { return '<div class="slider__item">' + b + '</div>'; }).join('')
          : productBlocks.join('');
        container.insertAdjacentHTML('beforeend', html);
        section.classList.remove('recently-viewed-products--hidden');
        section.classList.add('recently-viewed-products--loaded');
        var carousel = section.querySelector('carousel-slider');
        if (carousel && typeof carousel.refresh === 'function') carousel.refresh();
      } else {
        if (designMode) {
          section.classList.remove('recently-viewed-products--hidden');
          container.querySelector('noscript')?.remove();
          var placeholder = document.createElement('p');
          placeholder.className = 'align-center recently-viewed-products__placeholder';
          placeholder.textContent = emptyMessage;
          container.innerHTML = '';
          container.appendChild(placeholder);
        } else {
          section.classList.add('recently-viewed-products--hidden');
        }
      }
    }).catch(function(e) {
      console.warn('Recently viewed products:', e);
      if (designMode) {
        section.classList.remove('recently-viewed-products--hidden');
        container.querySelector('noscript')?.remove();
        var placeholder = document.createElement('p');
        placeholder.className = 'align-center recently-viewed-products__placeholder';
        placeholder.textContent = emptyMessage;
        container.innerHTML = '';
        container.appendChild(placeholder);
      } else {
        section.classList.add('recently-viewed-products--hidden');
      }
    });
  }

  function handleEditorEvent(e) {
    if (e.detail && document.querySelector('[data-section-id="' + e.detail.sectionId + '"].recently-viewed-products')) {
      initRecentlyViewedProducts();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyViewedProducts);
  } else {
    initRecentlyViewedProducts();
  }

  document.addEventListener('shopify:section:load', handleEditorEvent);
  document.addEventListener('shopify:section:select', handleEditorEvent);
})();
